module.exports = __webpack_public_path__ + "static/media/206-Telefonat_ID_62.fe3eee48.mp3";